<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <audio ref="ringing" autoplay playsinline></audio>
    <Header :leftArrow="true" @leftClick="onClickLeft" :rightIcons="false" />

    <div class="mypage mypage_sound" >
      <div class="wrap mypage_wrap">
        <ul class="mypage_sound-select">
          <li class="mypage_setting-item" v-for="(sound, index) in ringList" :key="index">
            <input :id="'select' + (index + 1)" type="radio" name="select" value="{{ sound.name }}"
              :checked="selectedRingingId === sound.ringing_id"
              @click="controlSingel(sound)">
            <label :for="'select' + (index + 1)">{{ sound.name }}</label>
            <button class="mypage_sound-btn" :class="[sound.status == 'playing'?'stop':'playback']">
              <img src="@/assets/img/mypage/sound_playback.png" alt="再生" class="playback" @click="doMusic(sound)">
              <img src="@/assets/img/mypage/sound_stop.png" alt="停止" class="stop"  @click="stopRinging">
            </button>
          </li>
        </ul>
      </div>
    </div>
<!--    <Footer />-->
  </div>
</template>

<script>
import { GetRingingList } from "@/services/ringing";
import { UpdateUser } from "@/services/user";
import Header from "@/components/Header.vue";
import {RefreshUserInfo} from "@/services/login";

export default {
  data() {
    return {
      ringList: [],
      ringing_id: "",
      id: null,
      isRinging_id: "",
      defaultRinging: null,
    };
  },
  components: {
    Header
  },
  mounted() {
    this.ringing_id = this.$route.query.ringing_id;
    this.id = parseInt(this.$route.query.id);
    this.initRingingList();
  },
  computed: {
    selectedRingingId() {
      if (this.ringing_id) {
        return this.ringing_id;
      }
      return this.defaultRinging && this.defaultRinging.ringing_id
        ? this.defaultRinging.ringing_id
        : "";
    },
  },
  methods: {
    doMusic(item) {
      this.stopRinging();
      if (item.video_path) {
        const prefix = process.env.NODE_ENV !== "development" ? "" : "api/";
        this.$refs.ringing.src = `${prefix}getRinging/${item.video_path}`;
        this.$refs.ringing.play();
        this.isRinging_id = item.ringing_id;
        item.status = 'playing';
      }
    },
    stopRinging() {
      this.isRinging_id = "";
      this.$refs.ringing.pause();
      this.ringList.forEach(item=>{
        item.status = 'stop';
      });
    },
    async initRingingList() {
      const res = await GetRingingList({ type: "msg" });
      if(res.data.data && res.data.data.list && res.data.data.list.length >0){
        this.ringList = res.data.data.list;
      }
      if(res.data.data && res.data.data.default){
        this.defaultRinging = res.data.data.default;
      }
      if(this.ringing_id && !this.ringList.some(item => item.ringing_id === this.ringing_id)){
        this.ringing_id = null;
        this.updateRouteQuery(null);
        let userRet = await RefreshUserInfo();
        let user = userRet.data.data.user;
        localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(user));
        this.$emit('initRing');
      }
    },
    onClickLeft() {
      history.back();
    },
    updateRouteQuery(set_ringing_id) {
      const query = {...this.$route.query};
      if (set_ringing_id) {
        query.ringing_id = set_ringing_id;
      } else {
        delete query.ringing_id;
      }
      this.$router.replace({
        path: this.$route.path,
        query
      });
    },
    async saveRinging(set_ringing_id) {
      this.updateRouteQuery(set_ringing_id);
      await UpdateUser({ id: this.id, ringing_id_msg: set_ringing_id });
      this.ringing_id = set_ringing_id;
      let userRet = await RefreshUserInfo();
      let user = userRet.data.data.user;
      localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(user));
      this.$emit('initRing');
    },
    controlSingel(item) {
      if (!this.ringing_id && this.defaultRinging && item.ringing_id === this.defaultRinging.ringing_id) {
        return;
      }
      const set_ringing_id = item.ringing_id === this.ringing_id ? null : item.ringing_id;
      this.saveRinging(set_ringing_id);
    },
  },
};
</script>

<style scoped>
   
  
   
.no-data {
  font-size: 18px;
  font-weight: 700;
  color: red;
}
</style>
